import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PurchaseHistory from "@/components/PurchaseHistory";

export default function Profile() {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && !user) nav("/login");
  }, [user, loading, nav]);

  if (loading || !user) return null;

  return (
    <div className="bg-ink min-h-screen has-player" data-testid="profile-page">
      <div className="max-w-4xl mx-auto px-5 md:px-10 py-12 md:py-16">
        <p className="scribble text-hotpink text-2xl rotate-[-2deg] inline-block mb-3">welcome back</p>
        <h1 className="brush-title text-5xl md:text-7xl text-white mb-2">
          HI, <span className="text-hotpink">{(user.name || user.email.split("@")[0]).toUpperCase()}.</span>
        </h1>
        <p className="font-outfit text-white/60 mb-10">Your unlocks, your receipts, your evidence.</p>
        <PurchaseHistory />
      </div>
    </div>
  );
}
